import type { GeoLevel } from '../hooks/useResolveProfileIds';

/**
 * Apply a geographic filter to a query filters object.
 * Works with TransitionsFiltersV2, CompositionV2Filters, or any
 * object that accepts country/region/msa/city as number[].
 */
export const applyGeoFilter = (
  filters: Record<string, unknown>,
  geo: GeoLevel
): void => {
  if (geo.type === 'country') filters.country = [geo.id];
  else if (geo.type === 'region') filters.region = [geo.id];
  else if (geo.type === 'msa') filters.msa = [geo.id];
  else if (geo.type === 'city') filters.city = [geo.id];
};
